import React from 'react';
import { useState } from 'react';
import { useEffect } from 'react';
import { useRef } from 'react';
import { useMemo } from 'react';
import { useContext } from "react";
//import { useCallback } from 'react';
import { useNavigate, useParams, useLocation } from 'react-router-dom';


//import axios from 'axios';
import axios_api from '../Api';

import { JsonForms } from '@jsonforms/react';
import { materialRenderers, materialCells } from '@jsonforms/material-renderers';

import Ajv from 'ajv';
import addFormats from 'ajv-formats';
import { rankWith, schemaTypeIs, uiTypeIs, createAjv } from '@jsonforms/core';
import localize_ru from 'ajv-i18n/localize/ru'; // Импорт русской локализации

//import CustomTextControl from './CustomTextRenderer';
import { CustomTableLabelControl, CustomFixedcellLabelControl, SmallLabelControl } from './CustomLabelRenderer';

import CustomNumberControl from './CustomNumberRenderer';
import CustomIntegerControl from './CustomIntegerRenderer';
import CustomGroupRenderer from './CustomGroupRenderer';
import { GetTaskStatus } from "./Task"

//import { blood_schema } from './FormBlood/FormBloodSchema_v4';
//import { blood_uiSchema } from './FormBlood/FormBloodUiSchema_v4';
//import { blood_formData } from './FormBlood/FormBloodData_v4';

import Loader from './common/Loader';
import ConfirmationModal from './common/ConfirmationModal';

import { API_URL, MEDIA_URL, AUTH_TOKEN } from '../Context';

// локализация дейтпикера в JsonForms
import dayjs from 'dayjs';
import 'dayjs/locale/ru';
dayjs.locale("ru");

/*
const options = {meta: true,}

const ajv = new Ajv({
  allErrors: true,
  verbose: true,
  strict: false,
  ...options,
});
addFormats(ajv);
*/

const ajvOptions = {  
  allErrors: true,
  verbose: true,
  strict: false,
}

const ajv = createAjv(ajvOptions)
require('ajv-keywords')(ajv);
require('ajv-errors')(ajv);
//console.log(ajv)


// Кастомный AJV с локализацией
const customAjv = {
  ...ajv,
  compile: (schema) => {
    // Компилируем схему с помощью стандартного AJV
    const validate = ajv.compile(schema);
    //console.log(validate)
    
    // Создаём кастомную функцию валидации
    const customValidate = (data) => {
      // Выполняем валидацию
      const valid = validate(data);
      // Если есть ошибки, локализуем их
      if (!valid && validate.errors) {
        // Применяем русскую локализацию
        localize_ru(validate.errors);
        // Корректируем кастомные сообщения из errorMessage
        //validate.errors.forEach((error) => {
        //  if (error.keyword === 'errorMessage' && error.params && error.params.errors) {
        //    error.message = error.params.errors[0].message;
        //  }
        //});
      }
      return valid;
    };

    Object.defineProperties(customValidate, {
      ...Object.getOwnPropertyDescriptors(validate),
      // Убедимся, что errors остаётся геттером
      errors: {
        get: () => validate.errors,
        enumerable: true,
      },
      // Сохраняем schema
      schema: {
        value: validate.schema,
        enumerable: true,
        writable: true,
      },
    });

    return customValidate;
  },
};


const numberSliderTester = rankWith(
  3, // Приоритет рендерера
  schemaTypeIs('number') // Условие: рендерить, если тип number
);
const integerSliderTester = rankWith(
  3, // Приоритет рендерера
  schemaTypeIs('integer') // Условие: рендерить, если тип integer
);
const groupTester = rankWith(
  3, 
  uiTypeIs('Group')
);


// Кастомные рендеры для отдельных типов полей
const renderers = [
  ...materialRenderers,
  //register custom renderers
  {
    tester: (uischema) => {
      return uischema.options && uischema.options.labelRenderer === 'fixed_cell' ? 100 : -1;
    },
    renderer: CustomFixedcellLabelControl,
  },
  {
    tester: (uischema) => {
      return uischema.options && uischema.options.labelRenderer === 'table_head' ? 100 : -1;
    },
    renderer: CustomTableLabelControl,
  },
  {
    tester: (uischema) => {
      return uischema.options && uischema.options.labelRenderer === 'small' ? 100 : -1;
    },
    renderer: SmallLabelControl,
  },
  {
    tester: numberSliderTester,
    renderer: CustomNumberControl,
  },
  {
    tester: integerSliderTester,
    renderer: CustomIntegerControl,
  },
  { 
    tester: groupTester, 
    renderer: CustomGroupRenderer, 
  }      
];

export { renderers };
// Кастомный хук для блокировки навигации

/*
function usePrompt(when, message) {
  const navigate = useNavigate();
  const location = useLocation();

  const handleNavigation = useCallback(
    (nextPath) => {
      if (when && location.pathname !== nextPath) {
        if (!window.confirm(message)) {
          return false; // Блокируем навигацию
        }
      }
      return true; // Разрешаем навигацию
    },
    [when, location, message]
  );

  useEffect(() => {
    // Перехватываем клики по ссылкам
    const handleLinkClick = (event) => {
      const link = event.target.closest('a');
      if (link && link.href) {
        const nextPath = new URL(link.href).pathname;
        if (!handleNavigation(nextPath)) {
          event.preventDefault();
        }
      }
    };

    //Перехватываем программную навигацию
    const originalPush = window.history.pushState;
    window.history.pushState = function (...args) {
      const nextPath = args[2]?.pathname || args[2] || '/';
      if (handleNavigation(nextPath)) {
        return originalPush.apply(this, args);
      }
    };

    window.addEventListener('click', handleLinkClick);
    return () => {
      window.removeEventListener('click', handleLinkClick);
      window.history.pushState = originalPush; // Восстанавливаем оригинальный pushState
    };
  }, [handleNavigation]);

  return navigate; // Возвращаем navigate для использования
}
*/

export default function FormRenderer ({}){

  //const validate = ajv.compile(test_schema1)
  //console.log(validate(test_formData1)) // false
  //console.log(validate.errors) // processed errors

  const api_url = useContext(API_URL);
  const token = useContext(AUTH_TOKEN);
  const navigate = useNavigate();

  const createTranslator = (locale) => (key, defaultMessage) => {
    //console.log(`Locale: ${locale}, Key: ${key}, Default Message: ${defaultMessage}`);
    //console.log(key)

    if(String(key) == "error.required"){
      return "Обязательное поле"
    } 

    //if(String(key) == "row_02.code_analizator2.error.custom"){
    //  return "должно быть"
    //}

    return defaultMessage;
  };
  
  const locale = 'ru'
  const translation = useMemo(() => createTranslator(locale), [locale]);
  //console.log(translation);

  //const schema = blood_schema;
  //const uischema = blood_uiSchema;
  //const schema = hormones_schema;
  //const uischema = hormones_uiSchema;

  const [uiSchema, setUiSchema] = useState({})

  const [loading, setLoading] = useState(true);
  const [taskParams, setTaskParams] = useState({});
  const [taskData, setTaskData] = useState({});

  const initialDataRef = useRef({});
  const [isDirty, setIsDirty] = useState(false);

  const [errors, setErrors] = useState([]);
  //const [samples, setSamples] = useState([]);

  const [validationMode, setValidationMode] = useState("ValidateAndHide");

  let { taskId } = useParams();
  taskId = Number(taskId);

  React.useEffect(() => {

    let taskData = axios_api.get(api_url + '/manage_task/' + taskId, {
      headers: {"Authorization": token}
    });
 
    taskData.then(
      (result) => {
        console.log(result.data)
        console.log("loading state: " + loading)
        setLoading(false);
        setTaskParams({
          'id': result.data.id,
          'form': result.data.form,
          'deadline_date': result.data.deadline_date,
          'completed_date': result.data.completed_date,
          'samples': result.data.samples.map(sample => <b>{sample.literal}-{sample.sample.sample_code} </b>),
          'status': result.data.status
        })


        // Вставляем номера ОПК в uiSchema для отображения в форме в таблице с измерениями  
        let newUiSchema = JSON.parse(JSON.stringify(result.data.form.form_ui_schema))
        //let newUiSchema = JSON.parse(JSON.stringify(uischema))
        let samplesDict = {}
        for (let i in result.data.samples) {
          samplesDict[result.data.samples[i].literal] = result.data.samples[i].sample.sample_code
        }
        //console.log(samplesDict);
        /*
        if (result.data.form.name == "Общие биохимические показатели крови") {
          newUiSchema.elements[6].elements[2].elements[1].text = 'ОПК А-' + samplesDict['A'] + ', Измерение 1';
          newUiSchema.elements[6].elements[2].elements[2].text = 'ОПК А-' + samplesDict['A'] + ', Измерение 2';
          newUiSchema.elements[6].elements[2].elements[3].text = 'ОПК B-' + samplesDict['B'] + ', Измерение 1';
          newUiSchema.elements[6].elements[2].elements[4].text = 'ОПК B-' + samplesDict['B'] + ', Измерение 2';
        }
        if (result.data.form.name == "Гормоны и витамины") {
          newUiSchema.elements[4].elements[3].elements[1].text = 'ОПК C-' + samplesDict['C'] + ', Измерение 1²';
          newUiSchema.elements[4].elements[3].elements[2].text = 'ОПК C-' + samplesDict['C'] + ', Измерение 2²';
          newUiSchema.elements[4].elements[3].elements[3].text = 'ОПК D-' + samplesDict['D'] + ', Измерение 1²';
          newUiSchema.elements[4].elements[3].elements[4].text = 'ОПК D-' + samplesDict['D'] + ', Измерение 2²';
          newUiSchema.elements[4].elements[3].elements[5].text = 'ОПК C-' + samplesDict['C'] + ', Измерение 1 (<,>)';
          newUiSchema.elements[4].elements[3].elements[6].text = 'ОПК C-' + samplesDict['C'] + ', Измерение 2 (<,>)';
          newUiSchema.elements[4].elements[3].elements[7].text = 'ОПК D-' + samplesDict['D'] + ', Измерение 1 (<,>)';
          newUiSchema.elements[4].elements[3].elements[8].text = 'ОПК D-' + samplesDict['D'] + ', Измерение 2 (<,>)';
        }
        */

        setUiSchema(newUiSchema)


        if (result.data.task_data != null) {
          setTaskData(result.data.task_data);
          initialDataRef.current = result.data.task_data;
        }
      },
      (error) => {
        console.log(error);
        setLoading(false);
      }
    );


  }, []);


  // кнопка "Проверить" - включить отображение ошибок заполнения формы
  function showFormValidation () {
    setValidationMode("ValidateAndShow")  
    window.scrollTo({
      top: 0,
      left: 0,
    })
  };


  // Сохранение результатов заполнения формы
  function saveTaskData () {
    let params = {'operation': 'update-task-data', 'task_data': taskData};
    console.log(params)

    axios_api.put(api_url + `/manage_task/` + taskId, params, {
      headers: {
        "Authorization": token, 
        //"Content-Type": "application/json",
      }
    })
    .then(
      (result) => {
        //console.log("Form data uploaded");
        setIsDirty(false)
        navigate("/");
        //navigate(0);
      },
      (error) => {
        console.log(error);
      }
    );
  }


  // Сохранение результатов заполнения формы и отправка результатов на проверку в ИАС
  function submitTask () {
    let params = {'operation': 'submit-task-for-check', 'task_data': taskData};
    console.log(params)
    
    axios_api.put(api_url + `/manage_task/` + taskId, params, {
      headers: {
        "Authorization": token, 
        //"Content-Type": "application/json",
      }
    })
    .then(
      (result) => {
        //console.log("Form data uploaded");
        setIsDirty(false)
        navigate("/");
        //navigate(0);
      },
      (error) => {
        console.log(error);
      }
    );
  }


  function ReturnTaskClick(taskId) {
    let params = {'operation': 'return-task-to-lab'};
    console.log(params)
    
    axios_api.put(api_url + `/manage_task/` + taskId, params, {
      headers: {
        "Authorization": token, 
        //"Content-Type": "application/json",
      }
    })
    .then(
      (result) => {
        navigate("/");
        navigate(0);
      },
      (error) => {
        console.log(error);
      }
    );
  }

  function DeleteTaskClick(taskId) {

    axios_api.delete(api_url + `/manage_task/` + taskId, {
      headers: {
        "Authorization": token, 
        //"Content-Type": "application/json",
      }
    })
    .then(
      (result) => {
        navigate("/");
        navigate(0);
      },
      (error) => {
        console.log(error);
        alert(error.response?.data)
      }
    );
  }
  
  function RemoveDataFromEAS(taskId) {
    //console.log(id)
    //let params = {'task_data': rowData.converted_data};
    //console.log(params)

    axios_api.delete(api_url + `/export_task_data/` + taskId, {
      headers: {
        "Authorization": token, 
        //"Content-Type": "application/json",
      }
    })
    .then(
      (result) => {
        console.log("Task data deleted from EAS");
        navigate('/task/' + taskId);
        navigate(0);
      },
      (error) => {
        console.log(error);
      }
    );
  }


  // Отслеживание изменений в форме
  function handleFormChange ({ data, errors }) {
    setTaskData(data);
    setErrors(errors); 

    const isFormDirty = JSON.stringify(data) !== JSON.stringify(initialDataRef.current);
    setIsDirty(isFormDirty);
  };

  
  // блокировка закрытия окна при несохраненных данных
  useEffect(() => {
    const handleBeforeUnload = (event) => {
      if (isDirty) {
        event.preventDefault();
        event.returnValue = ''; // Современный способ показать предупреждение
        return 'У вас есть несохранённые изменения. Уверены, что хотите уйти?';
      }
    };

    window.addEventListener('beforeunload', handleBeforeUnload);
    return () => window.removeEventListener('beforeunload', handleBeforeUnload);

  }, [isDirty]);
 

  // Блокировка внутренней навигации при несохраненных данных. Пока не работает.
  // usePrompt(isDirty, 'У вас есть несохранённые изменения. Уверены, что хотите уйти?');



  ////////////////////////////////////////////////////////////////////////////////
  // удаляем зведочки - это временное решение!! Нужен кастомный рендер для поля
  useEffect(() => {   
    let clearButtons = document.querySelectorAll("label > .MuiInputLabel-asterisk");
    [...clearButtons].forEach(e => {
        //console.log(e)
        e.remove();
      } 
    );
  });



  let statusDisplay = GetTaskStatus(taskParams.status);

  return loading ? 
    (
      <Loader/>
    ) : (
      <>
        {(Object.keys(taskParams).length > 0) && 
          <>

            <ConfirmationModal
              modalId="confirmTaskDeleteModal"
              headerText="Задание"
              messageText={[
                "Вы уверены, что хотите удалить задание?"
              ]}
              confirmButtonText="Удалить" 
              Action={() => DeleteTaskClick(taskId)}
              danger
            />

            <ConfirmationModal
              modalId="confirmTaskReturnModal"
              headerText="Договор"
              messageText={[
                "Вы уверены, что хотите вернуть задание лаборатории для исправления данных?"
              ]}
              confirmButtonText="Вернуть задание" 
              Action={() => ReturnTaskClick(taskId)}
            />

            <ConfirmationModal
              modalId="confirmTaskDataRemoveFromEAS"
              headerText="Задание"
              messageText={[
                "Вы уверены, что хотите удалить данные из промежуточной БД ИАС?"
              ]}
              confirmButtonText="Удалить данные" 
              Action={() => RemoveDataFromEAS(taskId)}
              danger
            />


            <div className="row m-3">
              <h3 className="">{taskParams.form.name}</h3>
            </div>

            <ConfirmationModal
              modalId="confirmSendDataModal"
              headerText="Результаты исследований"
              messageText={[
                "Вы уверены, что хотите отправить данные на проверку?"
              ]}
              confirmButtonText="Отправить данные" 
              Action={() => submitTask()}
            />

            <div className="row m-3">
              <div className='col-9'>
                <div className="form-head p-3 d-grid gap-3 d-md-flex justify-content-between">
                  <div>
                    <h6>Цикл: <b>{taskParams.form.cycle}</b></h6>
                    <h6>Представление результатов до: <b>{taskParams.deadline_date}</b></h6>
                    <h6>Результаты представлены: <b>{taskParams.completed_date}</b></h6>
                    <h6>Номера ОПК: {taskParams.samples}</h6>
                    <h6>Cтатус: <b>{statusDisplay}</b> </h6>
                  </div>
                  <div className="dropdown mt-3 me-3">
                    <button className="btn lk-button dropdown-toggle px-4" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                      Действия 
                    </button>
                    <ul className="dropdown-menu">
                      { taskParams.status == 'SENT' &&
                        <>
                          <button className='dropdown-item lk-menu-dropdown' data-bs-toggle="modal" data-bs-target="#confirmTaskReturnModal">Вернуть задание лаборатории</button>  
                          <button className='dropdown-item lk-menu-dropdown' onClick={() => navigate('/export/' + String(taskParams.id))}>Выгрузить данные в ИАС...</button>
                        </>
                      }
                      { taskParams.status == 'EXPORTED_TO_EAS' &&
                        <>
                          <button className="dropdown-item lk-menu-dropdown" data-bs-toggle="modal" disabled>Вернуть задание лаборатории</button>
                          <button className='dropdown-item lk-menu-dropdown' disabled> Выгрузить данные в ИАС...</button>
                          <button className='dropdown-item lk-menu-dropdown' data-bs-toggle="modal" data-bs-target="#confirmTaskDataRemoveFromEAS">Удалить данные из ИАС...</button>
                        </>
                      }
                      { !(['SENT', 'EXPORTED_TO_EAS'].includes(taskParams.status)) &&                   
                        <>
                          <button className="dropdown-item lk-menu-dropdown" data-bs-toggle="modal" disabled>Вернуть задание лаборатории</button>
                          <button className='dropdown-item lk-menu-dropdown' disabled> Выгрузить данные в ИАС...</button>
                        </>
                      }
                      <div className="dropdown-divider"></div>
                      <button className="dropdown-item lk-menu-dropdown" data-bs-toggle="modal" data-bs-target="#confirmTaskDeleteModal">Удалить задание</button>
                    </ul>
                  </div>
                </div>
              </div>
            </div>    

            { validationMode == "ValidateAndShow" ?
              <div className="row m-3">
                <div className='col-9'>
                  <div className="form-head p-3">
                    {errors.length > 0 ?
                      <h6 className='text-danger'><b>Пожалуйста исправьте ошибки ниже. Число полей с ошибками - {errors.length}</b></h6>
                    :
                      <h6 className='text-success'><b>Форма заполнена корректно. Ее можно отправить на проверку.</b></h6>
                    }
                  </div>
                </div>  
              </div>        
            :
              <></>
            }

            <div className="row ms-3 me-5">
              <JsonForms
                schema={taskParams.form.form_schema}
                //uischema={taskParams.form.form_ui_schema}
                //schema={schema}
                uischema={uiSchema}
                data={taskData}
                renderers={renderers}
                cells={materialCells}

                onChange={handleFormChange}
                /*onChange={({ data, errors }) => {
                    setTaskData(data);
                    setErrors(errors); 
                  }
                }*/
                /*onChange={({ data, errors }) => {
                    setData(data);
                    setErrors(localizeErrors(errors));
                  }
                }*/
                validationMode={validationMode}
                ajv={customAjv}
                i18n={{locale: locale, translate: translation}}
                //additionalErrors={errors}
              />
            </div>

            <div className="d-grid gap-2 d-md-flex justify-content-md-start mt-3 ms-4 ps-1 mb-5">
              <button onClick={saveTaskData} className='btn lk-button me-2'>Сохранить</button>
              <button onClick={showFormValidation} className='btn lk-button me-2'>Проверить</button>
              { validationMode == "ValidateAndShow" && errors.length == 0  && taskParams.status !== 'SENT' ?
                <button className='btn lk-button' data-bs-toggle="modal" data-bs-target="#confirmSendDataModal">Отправить форму</button>  
              :
                <button type="button" className="btn lk-button" disabled>Отправить форму</button>
              }
            </div>
          </>
        }
      </>      
    );
}





